import { type SemanticSIZES } from "semantic-ui-react";
import { type SizeProp } from "@fortawesome/fontawesome-svg-core";

export const semanticToFaSize: Record<SemanticSIZES, SizeProp> = {
  mini: "xs",
  tiny: "sm",
  small: "sm",
  medium: "lg",
  large: "lg",
  big: "xl",
  huge: "2xl",
  massive: "2x",
};
